module.exports = __webpack_public_path__ + "static/media/Canvas_508-06.a365a129.jpg";